import React from 'react';
import { connect } from 'react-redux';
import classes from './FilterStopover.scss';
import { selectStop } from '../../../store/actions/index';

const flightStopovers = [0, 1, 2];

const filterStopover = (props) => {
    return (
        <ul className={`u-flex`}>
            {flightStopovers.map((stopover, index) => (
                    <li onClick={() => props.onSelectStop(stopover)} key={index} className={[classes.StopOverListItem, props.stopoversActive.includes(stopover) ? classes.StopOverListItemActive : null].join(' ')}>
                        {stopover} Stop
                    </li>
                ))}
        </ul>
    );
}

const mapStateToProps = state => {
    return {
        stopoversActive: state.flights.selectedStops
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectStop: (stop) => dispatch(selectStop(stop))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(filterStopover);


// WEBPACK FOOTER //
// ./src/components/Filters/FilterStopover/FilterStopover.js